import { render, staticRenderFns } from "./newsList.vue?vue&type=template&id=3e38dcbe&"
import script from "./newsList.vue?vue&type=script&lang=js&"
export * from "./newsList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\work\\svn\\家用后台\\branches\\20240430-1.5.0\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3e38dcbe')) {
      api.createRecord('3e38dcbe', component.options)
    } else {
      api.reload('3e38dcbe', component.options)
    }
    module.hot.accept("./newsList.vue?vue&type=template&id=3e38dcbe&", function () {
      api.rerender('3e38dcbe', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/robot/news/newsList.vue"
export default component.exports